import React, { useState } from 'react';
import styles from './styles.module.scss';
import TicketsLayout from '@layouts/tickets';

const RequestsSection = () => {
    return (
        <div className={styles.wrapper}>
            <TicketsLayout />
        </div>
    );
};

export default RequestsSection;
